import { analysisCards } from "@/mocks/homeData";

export default function AnalysisSection() {
  return (
    <section id="analysis" className="w-full px-4 py-10 md:px-8 md:py-12">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4 border-b border-background-200 pb-3">
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-500 text-background-50">
            <i className="ri-file-search-line text-lg" style={{ lineHeight: 1 }} />
          </span>
          <div className="flex flex-col leading-tight">
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              细节分析 · 换个角度看
            </h2>
            <span className="text-xs text-foreground-500">不重复结论，只拆解那些容易被跳过的细节</span>
          </div>
        </div>
        <a
          href="#deepdive"
          className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700"
        >
          更多分析
          <i className="ri-arrow-right-s-line h-4 w-4" style={{ lineHeight: 1 }} />
        </a>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {analysisCards.map((card, index) => (
          <article
            key={card.title}
            className="reveal group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
            style={{ animationDelay: `${index * 70}ms` }}
          >
            <div className="flex items-center justify-between">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-50 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${card.icon} text-lg`} style={{ lineHeight: 1 }} />
              </span>
              <span className="rounded-sm bg-background-100 px-2 py-1 text-[11px] text-foreground-500">
                {card.angle}
              </span>
            </div>

            <h3 className="mt-3 text-sm font-bold leading-relaxed text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
              {card.title}
            </h3>
            <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">{card.excerpt}</p>

            <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-[11px] text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-list-check-2 h-3.5 w-3.5" style={{ lineHeight: 1 }} />
                {card.points} 个细节点
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-timer-line h-3.5 w-3.5" style={{ lineHeight: 1 }} />
                {card.readTime}
              </span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}